React = require 'react'
FormFields = require './internal/form-fields'
t = require('app/scripts/views/internal/recup-with-helpers')('credit_card')
{ formatMoney } = require 'app/scripts/lib/format/money'
localizeCount = require 'app/scripts/lib/localize-count'
OrgFeatures = require('@trello/product-features').OrganizationFeatures

module.exports = class extends React.Component
  displayName: 'SummaryComponent'

  formFields: []
  requiredFields: []

  render: t.renderable ->
    {
      monthlyProduct,
      yearlyProduct,
      billingStrategy,
      selectedBillingPlan,
      subTotalCost,
      tax,
      region,
      invitedUsersCount,
      invitedUsersSubTotal
    } = @props

    billableCollaboratorCount = billingStrategy.billableCollaboratorCount || 0
    licenseCount = billingStrategy.userCount
    isYearly = selectedBillingPlan.toString() == yearlyProduct.productNumber.toString()
    totalPlusTax = (parseFloat(subTotalCost) + parseFloat(tax || 0)).toFixed(2)
    licenseQuantityCopy = if isYearly then 'yearly-licenses' else 'monthly-licenses'

    showBillableCollaborators = (
      billableCollaboratorCount > 0 &&
      OrgFeatures.isFeatureEnabled 'multiBoardGuests', selectedBillingPlan
    )

    if showBillableCollaborators
      licenseCount += billableCollaboratorCount

    render = =>
      t.div '.billing-summary', ->
        t.h3 ->
          t.format 'billing-plan-summary'
        t.table ->
          t.tbody ->
            t.tr ->
              t.td ->
                t.span '.licences-quantity', ->
                  if billingStrategy.flatRate
                    t.format 'one-trello-gold-license'
                  else
                    t.text localizeCount licenseQuantityCopy, licenseCount
                if showBillableCollaborators
                  memberCount = localizeCount 'team-members', billingStrategy.userCount
                  mbgCount = localizeCount 'multi-board-guests', billableCollaboratorCount
                  t.div '.small.multi-board-guest-line-item', ->
                    t.format 'multi-board-guest-line-item', { memberCount, mbgCount }
                if isYearly
                  t.span '.save-info.small', ->
                    t.format 'monthly-saving-info',
                    savePercent: yearlyProduct.savePercent
                else
                  t.span '.switch-to-annual.small', ->
                    t.format 'annual-saving-info',
                      savePercent: yearlyProduct.savePercent
              t.td ->
                if invitedUsersCount
                  t.strong '.cost-each-monthly.price', ->
                    t.format 'amount-usd', amount: formatMoney subTotalCost
                else
                  t.strong '.cost-each-monthly.price', ->
                    t.format 'amount-usd', amount: formatMoney (if isYearly then yearlyProduct.price else monthlyProduct.monthlyPrice)
                  if !billingStrategy.flatRate
                    t.span '.small', ->
                      t.format 'each'
            if invitedUsersCount
              t.tr '.invited-users-billing-summary', ->
                t.td ->
                  t.span '.licences-quantity', ->
                    t.text invitedUsersCount
                    t.text ' Pending Invitations'
                t.td ->
                  t.strong '.cost-each-monthly.price', ->
                    t.format 'amount-usd', amount: formatMoney invitedUsersSubTotal
              t.tr '.invited-users-billing-description', ->
                t.td { colSpan: '2' }, ->
                  t.span '.small', ->
                    t.text "You'll be billed "
                    t.format 'amount-usd', amount: formatMoney (if isYearly then yearlyProduct.price else monthlyProduct.monthlyPrice)
                    t.text ' immediately for each team member that accepts your invitation.'
            t.tr ->
              t.td ->
                if region != null
                  t.format 'sales-tax',
                    region: (if tax then region else '')
                else
                  t.span '.u-form-error', ->
                    t.format 'could-not-calculate-sales-tax'
              t.td ->
                if tax != null
                  t.strong ->
                    t.format 'amount-usd', amount: formatMoney tax

          t.tfoot ->
            t.tr ->
              t.td ->
                t.format 'total-label'
              t.td ->
                t.strong '.price', ->
                  t.format 'amount-usd', amount: formatMoney totalPlusTax

    t.tag FormFields, {
      @formFields
      @requiredFields
      initialState: {}
      ref: (formFieldsRef) => @formFieldsRef = formFieldsRef
      render
    }
